module.exports = __webpack_public_path__ + "static/studio-a-control-room-7765beb5234ca60c45acf9f58193c0cc.jpg";